import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('./views/dashboard/index.vue'),
        meta: {
          title: '首页',
          auth: true,
        },
      },
    ],
  },
  {
    path: '/select-company',
    name: 'SelectCompany',
    component: () => import('./views/select-company/index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('./views/error-page/404.vue'),
    meta: {
    },
  },

  {
    path: '/403',
    name: 'NoAuth',
    component: () => import('./views/error-page/403.vue'),
    meta: {},
  },

  {
    path: '/401',
    name: 'NoLogin',
    component: () => import('./views/error-page/401.vue'),
    meta: {},
  },

  {
    path: '/redirect',
    component: () => import('@/layouts/main/index.vue'),
    children: [
      {
        name: 'Redirect',
        path: '/redirect/:path*',
        component: () => import('./views/redirect/index.vue'),
        meta: {},
      },
    ],
  },
] as IRouteConfig[];
